import Tutorial from './Tutorial';
import common from '../../common';
import WalkCommand from '../../commands/WalkCommand';
import {translate} from '../../utils';
import JumpCommand from '../../commands/JumpCommand';

export default class TutorialLevel2 extends Tutorial {
	constructor(finger, panel, scene, commands) {
		super(finger, panel, scene, commands);
	}

	update() {
		super.update();
	}

	play() {
		super.play();

		if (this._destroyed) {
			return;
		}

		this.tweens.removeAll();
		this._commands.ui.add.interactive = false;
		const secondLastCommandPos = this._commands.commands[this._commands.commands.length - 2].toGlobal(this._commands.ui.main);

		this._scene.cameraButton.interactive = false;

		let lastTween = null;

		if (this.stage === 0) {
			this._finger.rotation = 0;
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.position.set(secondLastCommandPos.x + 140, secondLastCommandPos.y + 35);
			this._commands.commands[2].locked = true;
			this._commands.commands[2].grabbable = false;
			common.focusOverlay.setFocus(20, 10, 250, 450);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE2.DELETE');
			this.signals.update.dispatch();

			new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 250)
				.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
				.delay(500)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 250)
				.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
				.delay(500)
				.start();
		} else if (this.stage === 1) {
			this._finger.position.set(secondLastCommandPos.x + 140, secondLastCommandPos.y + 35);
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			common.focusOverlay.setFocus(20, 10, 250, 750);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE2.DELETE');
			this.signals.update.dispatch();

			this._commands.ui.disposal.visible = true;

			const t1 = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					y: 750
				}, 750)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.interpolation(P3.utils.TWEEN.Interpolation.Bezier)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					alpha: 0
				}, 500)
				.easing(P3.utils.TWEEN.Easing.Linear.None);

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 2) {
			this._finger.position.set(secondLastCommandPos.x + 140, 190);
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			common.focusOverlay.setFocus(20, 10, 250, 350);

			this._commands.commands[2].locked = false;
			this._commands.commands[2].grabbable = true;

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE2.DRAG');
			this.signals.update.dispatch();

			const t1 = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					y: 310
				}, 750)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.interpolation(P3.utils.TWEEN.Interpolation.Bezier)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					alpha: 0
				}, 500)
				.easing(P3.utils.TWEEN.Easing.Linear.None);

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 3) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 100 - this._commands.ui.x, common.STAGE_HEIGHT - 180);
			common.focusOverlay.focusSprite(this._scene.runButton, true);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE2.RUN');
			this.signals.update.dispatch();

			new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 500)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 500)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();
		}

		if (lastTween) {
			lastTween.onComplete(() => {
				P3.utils.delayg(this.tweens, 1, () => {
					if (common.currentLevel === 1) {
						this.play();
					}
				});
			});
		}
	}

	stop() {
		super.stop();
	}

	prepareCommands() {
		super.prepareCommands();

		for (let i = 0; i < 4; i++) {
			let command = null;

			if (i !== 1) {
				command = new WalkCommand();
			} else {
				command = new JumpCommand();
			}

			command.locked = i === 0;

			command.template = false;
			command.grabbable = false;
			command.placed = true;
			command.locked = true;
			this._commands.commandContainer.addChild(command);
			command.x = 169;
			command.setText(command.defaultVariable);
			for (const comm of this._commands.commands) {
				comm.slotPosition.set(comm.position.x, comm.position.y);
			}

			this._commands.commands.splice(i + 1, 0, command);

			if (i === 1 || i === 3) {
				command.locked = false;
				command.grabbable = true;
				command.signals.pickup.detachAll();
				command.signals.pickup.add(this._commands.onCommandPickup, this._commands);
				command.signals.move.add(this._commands.onCommandMove, this._commands);
				command.signals.touch.add(this._commands.onCommandTouch, this._commands);
				command.signals.release.add(this._commands.checkCommand, this._commands);
				command.signals.onVariableTouch.add(this._commands.onVariableTouch, this._commands);
			}

			this._commands.resize();
		}
	}
}
